import { render } from "./assenzaCliente.vue?vue&type=template&id=0a160d76&ts=true"
import script from "./assenzaCliente.vue?vue&type=script&lang=ts"
export * from "./assenzaCliente.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__